export default ({ rating, count, recommendRate }) => ({
  visibility: 'everywhere',
  type: 'multi_column',
  skuPattern: '.*',
  id: '63538704',
  disableBottomMargin: null,
  columns: [
    {
      type: 'stack',
      titleSize: 'lg',
      title: 'What our customers say about SunGod.',
      subtitle: '',
      showCta: true,
      link: '',
      image: null,
      fullHeight: null,
      ctaType: 'link',
      ctaLink: '/reviews',
      ctaCopy: 'Read the Reviews',
      copySize: 'regular',
      copy: '',
      aspectRatio: 'auto'
    },
    {
      type: 'blank',
      id: '63538703'
    },
    {
      type: 'stack',
      titleSize: 'xl',
      title: `${rating}/5`,
      subtitle: '',
      showCta: false,
      link: '',
      image: {
        width: 2108,
        title: null,
        src: 'https://www.datocms-assets.com/45158/1619611239-screenshot-2021-04-28-133530.jpg',
        height: 280,
        focalPoint: {
          y: 0.5,
          x: 0.5
        },
        alt: null
      },
      fullHeight: null,
      ctaType: 'button',
      ctaLink: '',
      ctaCopy: '',
      copySize: 'regular',
      copy: `from ${count} verified customer reviews.`,
      aspectRatio: 'auto'
    },
    {
      type: 'stack',
      titleSize: 'xl',
      title: recommendRate,
      subtitle: '',
      showCta: false,
      link: '',
      image: {
        width: 2108,
        title: null,
        src: 'https://www.datocms-assets.com/45158/1619611232-screenshot-2021-04-28-133530.jpg',
        height: 280,
        focalPoint: {
          y: 0.5,
          x: 0.5
        },
        alt: null
      },
      fullHeight: null,
      ctaType: 'button',
      ctaLink: '',
      ctaCopy: '',
      copySize: 'regular',
      copy: 'of customers would recommend SunGod to a friend.',
      aspectRatio: 'auto'
    }
  ]
})
